import { useState } from 'react';

interface MultiSelectProps {
  label: string;
  options: string[];
  selected: string[] | null;
  onSelectionChange: (selected: string[] | null) => void;
  wildcards?: { label: string; onApply: () => void }[];
}

export default function MultiSelect({ label, options, selected, onSelectionChange, wildcards }: MultiSelectProps) {
  const [query, setQuery] = useState('');
  const chosen = selected ?? options;
  const all = options.length > 0 && chosen.length === options.length;
  return <details className="policy-select">
    <summary><span>{label}</span><strong>{all ? 'All' : !chosen.length ? '0 selected' : chosen.length <= 2 ? chosen.join(', ') : `${chosen.length} selected`}</strong></summary>
    <div className="policy-select-body">
      <input type="search" aria-label={`Search ${label}`} placeholder={`Find ${label.toLowerCase()}…`} value={query} onChange={e => setQuery(e.target.value)} />
      <div className="policy-selection-actions"><button type="button" aria-label={`Select all ${label.toLowerCase()}`} aria-pressed={all} onClick={() => { onSelectionChange(null); setQuery(''); }}>All</button><button type="button" aria-label={`Clear ${label.toLowerCase()}`} onClick={() => { onSelectionChange([]); setQuery(''); }}>Clear</button>
      {wildcards?.map(w => <button key={w.label} onClick={w.onApply}>{w.label}</button>)}</div>
      <p className="control-help">{chosen.length} of {options.length} selected.</p>
      <div className="policy-options">{options.filter(item => item.toLowerCase().includes(query.toLowerCase())).map(item => <label key={item}>
        <input type="checkbox" checked={chosen.includes(item)} onChange={e => onSelectionChange(e.target.checked ? [...chosen, item] : chosen.filter(value => value !== item))} />{item}
      </label>)}</div>
    </div>
  </details>;
}
